import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import dataReducer from './data/reducer';
import dataSaga from './data/sagas';
import detailsReducer from './detailsPage/data/reducer';
import detailsSaga from './detailsPage/data/sagas';
import listReducer from './listPage/data/reducer';
import listSaga from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  data: dataReducer,
  listPage: listReducer,
  detailsPage: detailsReducer,
});

const saga = function* () {
  yield all([dataSaga(), listSaga(), detailsSaga()]);
};

export { reducer, saga, routes };
